import {Box, Button, Card, CardContent, CircularProgress, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {formatDateNow} from "../../i18n/date-formatting";

export function CountValue({result}) {
    const {t, i18n} = useTranslation();
    if (result.status === "loading") return <CircularProgress size={24} aria-label={t("Loading")}/>;
    return <Typography variant="h4">{result.status === "success" ? new Intl.NumberFormat(i18n.language).format(result.count) : "—"}</Typography>;
}

export function CountContext({result}) {
    const {t, i18n} = useTranslation();
    if (result.status === "success") return <Typography variant="caption" color="text.secondary" display="block">
        {t("OverviewCheckedAt", {time: formatDateNow(result.checkedAt, (i18n.language || "en").split("-")[0], true)})}
    </Typography>;
    return <Box><Typography variant="body2" color="text.secondary" role={result.status === "error" ? "alert" : undefined}>
        {t(result.status === "error" ? "OverviewLoadFailed" : result.status === "loading" ? "Loading" : "DistributorMetricUnavailable")}
    </Typography>{result.status === "error" && <Button size="small" onClick={result.reload}>{t("Retry")}</Button>}</Box>;
}

export function MetricCard({title, icon: Icon, result, description, action}) {
    const {t} = useTranslation();
    return <Card component="section" aria-label={t(title)} variant="outlined" sx={{height: "100%", borderRadius: 2}}><CardContent>
        <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={1}>
            <Typography variant="body2" color="text.secondary">{t(title)}</Typography>
            <Icon sx={{color: "primary.main", fontSize: 22, flexShrink: 0}}/>
        </Box>
        <Box sx={{my: 1.5, minHeight: 42}}><CountValue result={result}/></Box>
        <Typography variant="body2" color="text.secondary" sx={{mb: 1}}>{description}</Typography>
        <CountContext result={result}/>
        {action && <Button size="small" onClick={action.onClick} sx={{mt: 1}}>{t(action.label)}</Button>}
    </CardContent></Card>;
}

export function AttentionItem({title, description, result, onClick}) {
    const {t} = useTranslation();
    return <Box component="section" aria-label={t(title)} sx={{border: 1, borderColor: "divider", borderRadius: 2, p: 2}}>
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2}}>
            <Box sx={{minWidth: 0}}><Typography variant="subtitle1" fontWeight={600}>{t(title)}</Typography>
                <Typography variant="body2" color="text.secondary">{t(description)}</Typography></Box>
            <CountValue result={result}/>
        </Box>
        {result.status === "success" && <Typography role="status" variant="body2" sx={{mt: 1}}>
            {t(result.count === 0 ? "OverviewNoAttention" : "OverviewActionAvailable")}</Typography>}
        <CountContext result={result}/>
        {result.status === "success" && result.count > 0 && <Button onClick={onClick} sx={{mt: 1}}>{t("OverviewReviewOrders")}</Button>}
    </Box>;
}
